module.exports = __webpack_public_path__ + "dimer/static/img/13.40f8ea9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/13.jpg
// module id = y6Po
// module chunks = 0